import React from 'react';
import PropTypes from 'prop-types';
import s from './Breadcrumbs.css';
import { Link } from 'react-router-dom';
import Icon from '../Icon';

class Breadcrumbs extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={s.root}>
        <Link to={this.props.link}>
          <Icon icon="arrow_left" />
          {this.props.title}
        </Link>
      </div>
    );
  }
}

export default (Breadcrumbs);



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/Breadcrumbs.js